import { StyleSheet, View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TouchableNoFeedback } from '@flix/common/elements/controls'
import { cursorPointer } from '@flix/common/style/webStyles'

const TouchableContainer = styled(TouchableNoFeedback)`
  padding-right: ${(props) => props.theme.spacing.smedium}px;
  padding-bottom: ${(props) => props.theme.spacing.smedium}px;
  margin-bottom: ${(props) => props.theme.spacing.medium}px;
  ${(props) => props.onPress && cursorPointer};
`

const Background = styled(View)`
  background-color: ${(props) => (props.color ? props.theme.colors[props.color] : 'transparent')};
  margin-top: ${(props) => props.theme.spacing.smedium}px;
  margin-left: ${(props) => props.theme.spacing.smedium}px;
`

const Foreground = styled(View)`
  background-color: ${(props) => props.theme.colors.foreground};
`

export const BlockBackgrounded = ({ onLayout, onPress, highlight, color, children, style }) => (
  <TouchableContainer onPress={onPress} style={style}>
    <Background style={StyleSheet.absoluteFill} color={color ?? (highlight ? 'primary' : null)} />
    <Foreground onLayout={onLayout}>{children}</Foreground>
  </TouchableContainer>
)

BlockBackgrounded.propTypes = {
  onLayout: PropTypes.func.isRequired,
  onPress: PropTypes.func,
}
